export const FETCH_ANNOUNCEMENTS_INTERVAL = 1000 * 60 * 60; // Only query backend for announcements on page-load every 1 hour
